var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-form"},[_c('div',[_c('SummaryTable')],1),_c('div',[_c('OperationalTable')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }